module.exports = {"513335100":"夏邛镇","513335101":"中咱镇","513335102":"措拉镇","513335200":"拉哇乡","513335201":"党巴乡","513335202":"竹巴龙乡","513335203":"中心绒乡","513335204":"苏哇龙乡","513335205":"昌波乡","513335206":"地巫乡","513335208":"亚日贡乡","513335209":"波密乡","513335210":"莫多乡","513335211":"松多乡","513335212":"波戈溪乡","513335213":"甲英乡","513335215":"茶洛乡","513335216":"列衣乡","513335217":"德达乡"}


//////////////////
// WEBPACK FOOTER
// ./src/town/513335.json
// module id = 2426
// module chunks = 0